import { Stack, Typography } from '@mui/material';

import { DayCircle } from './DayColumnHeader.styles';

export function DayColumnHeader({
  dayName,
  day,
  isToday,
  isHoliday
}: {
  dayName: string;
  day: number;
  isToday?: boolean;
  isHoliday?: boolean;
}) {
  return (
    <Stack alignItems="center">
      <Typography
        variant="caption"
        sx={{
          fontFamily: isToday || isHoliday ? 'SourceSansPro-Bold' : 'inherit'
        }}
      >
        {dayName}
      </Typography>
      {isToday || isHoliday ? (
        <DayCircle isHoliday={isHoliday}>
          <Typography
            variant="caption"
            sx={{ fontFamily: 'SourceSansPro-Bold' }}
          >
            {day}
          </Typography>
        </DayCircle>
      ) : (
        <Typography variant="caption">{day}</Typography>
      )}
    </Stack>
  );
}
